<div mat-dialog-title class="justify-content-center align-items-center" style="margin-top: -10px !important;">
    <span *ngIf="!multiple && !deleted && !error && !isCancelComplete()">¿Desea eliminar la solicitud {{order?.orderId}}?</span>
    <span *ngIf="multiple && !deleted && !error && !isCancelComplete()">¿Desea eliminar las solicitudes?</span>

    <mat-icon *ngIf="deleted && !error" style="color: green; font-size: 40px; height: 40px; width: 40px;" class="mr-3">done</mat-icon>
    <span *ngIf="deleted && !error">La operación se realizó correctamente  </span>
    <span *ngIf="isCancelComplete() && !hasErrors()">La operación se realizó correctamente  </span>  
    <span *ngIf="isCancelComplete() && hasErrors()">La operación se realizó con errores  </span>  

    <mat-icon *ngIf="error" style="color: red; font-size: 40px; height: 40px; width: 40px;" class="mr-3">close</mat-icon>
    <span *ngIf="error"> Se produjo un error </span>
</div> 
<div mat-dialog-content>
  <ul *ngIf="multiple && !isCancelComplete()">
    <li *ngFor="let order of orders">{{order.orderId}}</li>
  </ul>

  <ul *ngIf="multiple && isCancelComplete()">
    <li *ngFor="let order of ids; let i = index">{{order.orderId}} 
      <mat-icon class="icon-error" *ngIf="order.error">close</mat-icon>
      <mat-icon class="icon-done" *ngIf="!order.error">done</mat-icon>
    </li>
  </ul>
  
</div>

  <div mat-dialog-footer>
    
  </div>

  <mat-dialog-actions align="center" >
      <ng-container *ngIf="!deleted && !error && !isCancelComplete()">
        <button mat-raised-button mat-dialog-close color="warn">No</button>
        <button mat-raised-button *ngIf="!multiple" (click)="deleteOrder()" color="primary">Si</button>
        <button mat-raised-button *ngIf="multiple" (click)="deleteOrders()" color="primary">Si</button>

      </ng-container>
      <ng-container *ngIf="error || deleted || isCancelComplete()">
        <button mat-raised-button [mat-dialog-close]="deleted ||  isCancelComplete() ? true : false" color="primary">Cerrar</button>
      </ng-container>
    
    <!--button mat-raised-button [mat-dialog-close]="" (click) color="primary">Si</button-->

  </mat-dialog-actions>
